import React, { useEffect, useState, lazy, Component } from 'react';
import { useScreenInit } from './useScreenInit.js';
// ─── CONSTANTS ────────────────────────────────────────────────
const WHATSAPP = '13213325840';
const WA_MSG = encodeURIComponent("Hi! I found you at sunroutemobilitygroup.com — I'm interested in renting the 2017 Ford Fusion SE. Is it available?");
const ADMIN_USER = 'admin';
const ADMIN_PASS = 'southroute2025';
const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const DAY_NAMES = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
// ─── CAR PHOTOS ───────────────────────────────────────────────
const CAR_PHOTOS = [{
  src: 'https://cdn.magicpatterns.com/uploads/7cA14nNbQwuhemQpjRTJRr/IMG_4453.jpg',
  alt: 'Ford Fusion SE — front view'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/ohLzS2oi9NacRVvfpUykb5/IMG_4451.jpg',
  alt: 'Ford Fusion SE — side angle'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/bzcWgNpw9NYrhzu4wR7TF1/IMG_4457.jpg',
  alt: 'Ford Fusion SE — rear view with palm tree'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/ba2v95htTvxGNZHhUKRCDG/IMG_4458.jpg',
  alt: 'Ford Fusion SE — front grille'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/kx8jE17i2ejXy7e6tn2km7/IMG_4465.jpg',
  alt: 'Ford Fusion SE — interior dashboard'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/g1EyYxtHvnbexkf3p93XCE/IMG_4464.jpg',
  alt: 'Ford Fusion SE — interior cabin view'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/qiqb1uWf1ttxHSPiSJeh24/IMG_4467.jpg',
  alt: 'Ford Fusion SE — rear seats in leather'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/t8ojT74qptpYSL15D7yZKS/IMG_4470.jpg',
  alt: 'Ford Fusion SE — open trunk space'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/ebtzz1CAWDdw5rVUYM2rZ8/IMG_4472.jpg',
  alt: 'Ford Fusion SE — driver view with steering wheel'
}];
// ─── CAR CAROUSEL ─────────────────────────────────────────────
const CarCarousel = () => {
  const [index, setIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const total = CAR_PHOTOS.length;
  // auto-advance every 5s when not hovered
  useEffect(() => {
    if (isHovered) return;
    const t = setInterval(() => setIndex(i => (i + 1) % total), 5000);
    return () => clearInterval(t);
  }, [isHovered, total]);
  const go = i => setIndex((i % total + total) % total);
  const prev = () => go(index - 1);
  const next = () => go(index + 1);
  return <div onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} style={{
    background: 'linear-gradient(135deg, #0f2040 0%, #0a1628 100%)',
    borderRadius: 12,
    marginBottom: '1.2rem',
    position: 'relative',
    overflow: 'hidden',
    aspectRatio: '4 / 3'
  }} data-id="element-0">
      {/* slides */}
      <div style={{
      display: 'flex',
      width: `${total * 100}%`,
      height: '100%',
      transform: `translateX(-${index * 100 / total}%)`,
      transition: 'transform 0.55s cubic-bezier(0.65, 0, 0.35, 1)'
    }} data-id="element-1">
        {CAR_PHOTOS.map((p, i) => <div key={p.src} style={{
        width: `${100 / total}%`,
        height: '100%',
        position: 'relative'
      }} data-id="element-2">
            <img src={p.src} alt={p.alt} loading={i === 0 ? 'eager' : 'lazy'} style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          display: 'block'
        }} data-id="element-3" />
          </div>)}
      </div>

      {/* gradient overlay at bottom for controls */}
      <div style={{
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      height: 90,
      background: 'linear-gradient(to top, rgba(10,22,40,0.85) 0%, transparent 100%)',
      pointerEvents: 'none'
    }} data-id="element-4" />

      {/* prev / next */}
      {[{
      dir: 'prev',
      onClick: prev,
      side: {
        left: 12
      },
      char: '‹'
    }, {
      dir: 'next',
      onClick: next,
      side: {
        right: 12
      },
      char: '›'
    }].map(b => <button key={b.dir} onClick={b.onClick} aria-label={b.dir === 'prev' ? 'Previous photo' : 'Next photo'} style={{
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      ...b.side,
      width: 38,
      height: 38,
      borderRadius: '50%',
      background: 'rgba(10,22,40,0.6)',
      backdropFilter: 'blur(8px)',
      border: '1px solid rgba(201,168,76,0.4)',
      color: '#c9a84c',
      fontSize: '1.4rem',
      lineHeight: 1,
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'background 0.2s, transform 0.2s',
      paddingBottom: 3
    }} onMouseOver={e => {
      e.currentTarget.style.background = 'rgba(201,168,76,0.9)';
      e.currentTarget.style.color = '#0a1628';
    }} onMouseOut={e => {
      e.currentTarget.style.background = 'rgba(10,22,40,0.6)';
      e.currentTarget.style.color = '#c9a84c';
    }} data-id="element-5">
          {b.char}
        </button>)}

      {/* counter */}
      <div style={{
      position: 'absolute',
      top: 12,
      right: 12,
      background: 'rgba(10,22,40,0.7)',
      backdropFilter: 'blur(8px)',
      color: '#c9a84c',
      fontSize: '0.7rem',
      fontWeight: 600,
      padding: '0.3rem 0.65rem',
      borderRadius: 20,
      border: '1px solid rgba(201,168,76,0.3)',
      letterSpacing: '1px'
    }} data-id="element-6">
        {String(index + 1).padStart(2, '0')} / {String(total).padStart(2, '0')}
      </div>

      {/* dots */}
      <div style={{
      position: 'absolute',
      bottom: 14,
      left: 0,
      right: 0,
      display: 'flex',
      justifyContent: 'center',
      gap: 8
    }} data-id="element-7">
        {CAR_PHOTOS.map((_, i) => <button key={i} onClick={() => go(i)} aria-label={`Go to photo ${i + 1}`} style={{
        width: i === index ? 22 : 8,
        height: 8,
        borderRadius: 4,
        background: i === index ? '#c9a84c' : 'rgba(255,255,255,0.4)',
        border: 'none',
        cursor: 'pointer',
        padding: 0,
        transition: 'all 0.3s'
      }} data-id="element-8" />)}
      </div>
    </div>;
};
// ─── LEGAL CONTENT ────────────────────────────────────────────
const LEGAL_CONTENT = {
  terms: {
    title: 'Terms & Conditions',
    updated: 'Updated January 2026',
    sections: [{
      h: '1. Rental Agreement',
      p: "By renting a vehicle from SunRoute Mobility Group LLC, you agree to comply with all applicable laws and the conditions outlined in your signed rental agreement. The renter must be at least 21 years old and hold a valid driver's license."
    }, {
      h: '2. Payment & Security Deposit',
      p: 'The daily rate is $60 USD. A refundable security deposit of $100 USD is required before the keys are handed over. The deposit is returned in full within 48 hours after vehicle inspection, provided no damage, fines, or missing items are detected.'
    }, {
      h: '3. Insurance',
      p: 'SunRoute Mobility Group LLC does NOT provide insurance coverage. The renter is fully responsible for obtaining their own insurance (personal auto policy, Turo protection plan, or third-party coverage) before driving the vehicle. Driving without insurance is prohibited.'
    }, {
      h: '4. Vehicle Use',
      p: 'The vehicle may only be used for lawful personal or business transportation within the state of Florida. Subletting, ride-sharing services (Uber/Lyft), off-road use, racing, or transporting hazardous materials is strictly forbidden.'
    }, {
      h: '5. Fuel & Mileage',
      p: 'The vehicle is delivered with a full tank and must be returned with a full tank. Refueling fees apply otherwise. Standard rentals include up to 200 miles per day; additional mileage is billed at $0.25 per mile.'
    }, {
      h: '6. Damages & Fines',
      p: 'The renter is liable for any damage, traffic violations, toll charges, or parking fines incurred during the rental period. Damages exceeding the deposit will be billed separately.'
    }, {
      h: '7. Cancellation',
      p: 'Cancellations made more than 48 hours before the pickup time receive a full refund. Cancellations within 48 hours forfeit the security deposit.'
    }]
  },
  privacy: {
    title: 'Privacy Policy',
    updated: 'Updated January 2026',
    sections: [{
      h: '1. Information We Collect',
      p: "We collect personal information you provide directly to us — including your full name, driver's license number, phone number, email address, and payment information — solely for the purpose of processing your rental reservation."
    }, {
      h: '2. How We Use Your Information',
      p: 'Your information is used to verify identity, confirm bookings, communicate via WhatsApp or email, process payments, and comply with Florida state regulations for vehicle rentals.'
    }, {
      h: '3. Information Sharing',
      p: 'We do NOT sell, rent, or trade your personal data. Information may only be disclosed to law enforcement when required by law, or to our insurance provider in the event of an accident or incident.'
    }, {
      h: '4. WhatsApp Communications',
      p: "When you contact us via WhatsApp, your phone number and messages are stored within Meta's WhatsApp Business platform under their privacy policy. We retain these conversations to maintain accurate booking records."
    }, {
      h: '5. Data Retention',
      p: 'Rental records are retained for 5 years to comply with tax and legal obligations. After that period, personal data is securely deleted.'
    }, {
      h: '6. Your Rights',
      p: 'You have the right to access, correct, or request deletion of your personal data. To exercise these rights, contact us at sunroutemobilitygroupllc@outlook.com.'
    }, {
      h: '7. Contact',
      p: 'SunRoute Mobility Group LLC · Orlando, Florida · sunroutemobilitygroupllc@outlook.com · +1 (321) 332-5840'
    }]
  }
};
// ─── LEGAL MODAL ──────────────────────────────────────────────
const LegalModal = ({
  type,
  onClose
}) => {
  const content = LEGAL_CONTENT[type];
  if (!content) return null;
  return <div onClick={onClose} style={{
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.75)',
    zIndex: 999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1rem',
    animation: 'fadeUp 0.25s ease both'
  }} data-id="element-9">
      <div onClick={e => e.stopPropagation()} style={{
      background: '#fff',
      borderRadius: 14,
      maxWidth: 640,
      width: '100%',
      maxHeight: '85vh',
      display: 'flex',
      flexDirection: 'column',
      boxShadow: '0 24px 80px rgba(0,0,0,0.5)',
      overflow: 'hidden'
    }} data-id="element-10">
        <div style={{
        background: '#0a1628',
        padding: '1.4rem 1.8rem',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        borderBottom: '2px solid #c9a84c'
      }} data-id="element-11">
          <div data-id="element-12">
            <div style={{
            fontFamily: "'Cormorant Garamond', serif",
            fontSize: '1.5rem',
            fontWeight: 700,
            color: '#c9a84c',
            lineHeight: 1.2
          }} data-id="element-13">
              {content.title}
            </div>
            <div style={{
            fontSize: '0.68rem',
            color: 'rgba(255,255,255,0.5)',
            textTransform: 'uppercase',
            letterSpacing: '2px',
            marginTop: 4
          }} data-id="element-14">
              SunRoute Mobility Group LLC · {content.updated}
            </div>
          </div>
          <button onClick={onClose} aria-label="Close" style={{
          background: 'transparent',
          border: '1px solid rgba(201,168,76,0.4)',
          color: '#c9a84c',
          width: 32,
          height: 32,
          borderRadius: 4,
          cursor: 'pointer',
          fontSize: '1rem',
          flexShrink: 0,
          marginLeft: '1rem'
        }} data-id="element-15">
            ✕
          </button>
        </div>
        <div style={{
        padding: '1.6rem 1.8rem',
        overflowY: 'auto',
        flex: 1
      }} data-id="element-16">
          {content.sections.map((s, i) => <div key={i} style={{
          marginBottom: '1.3rem'
        }} data-id="element-17">
              <div style={{
            fontSize: '0.85rem',
            fontWeight: 600,
            color: '#0a1628',
            marginBottom: '0.45rem',
            fontFamily: "'Outfit', sans-serif"
          }} data-id="element-18">
                {s.h}
              </div>
              <p style={{
            fontSize: '0.84rem',
            color: '#475569',
            lineHeight: 1.7,
            fontWeight: 300
          }} data-id="element-19">
                {s.p}
              </p>
            </div>)}
          <div style={{
          marginTop: '1rem',
          padding: '1rem',
          background: '#f5f1e8',
          borderRadius: 6,
          fontSize: '0.75rem',
          color: '#64748b',
          lineHeight: 1.6,
          borderLeft: '3px solid #c9a84c'
        }} data-id="element-20">
            For questions about this {content.title.toLowerCase()}, contact us
            at{' '}
            <strong style={{
            color: '#0a1628'
          }} data-id="element-21">
              sunroutemobilitygroupllc@outlook.com
            </strong>
            .
          </div>
        </div>
        <div style={{
        padding: '0.9rem 1.8rem',
        borderTop: '1px solid #e2e8f0',
        background: '#f8fafc',
        textAlign: 'right'
      }} data-id="element-22">
          <button onClick={onClose} style={{
          background: '#0a1628',
          color: '#c9a84c',
          border: 'none',
          padding: '0.6rem 1.4rem',
          borderRadius: 5,
          fontSize: '0.82rem',
          fontWeight: 600,
          cursor: 'pointer',
          fontFamily: "'Outfit', sans-serif",
          letterSpacing: '0.5px'
        }} data-id="element-23">
            Close
          </button>
        </div>
      </div>
    </div>;
};
// ─── FONT IMPORT ──────────────────────────────────────────────
const FontLoader = () => <style data-id="element-24">{`
    @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;600;700;900&family=Outfit:wght@300;400;500;600&display=swap');
    *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
    body { font-family: 'Outfit', sans-serif; background: #0a1628; }
    html { scroll-behavior: smooth; }
    @keyframes fadeUp {
      from { opacity: 0; transform: translateY(24px); }
      to   { opacity: 1; transform: translateY(0); }
    }
    @keyframes pulse {
      0%, 100% { opacity: 1; }
      50%       { opacity: 0.35; }
    }
    @keyframes shimmer {
      0%   { background-position: -200% center; }
      100% { background-position: 200% center; }
    }
    .fade-up { animation: fadeUp 0.7s ease both; }
    .fade-up-1 { animation: fadeUp 0.7s 0.1s ease both; }
    .fade-up-2 { animation: fadeUp 0.7s 0.2s ease both; }
    .fade-up-3 { animation: fadeUp 0.7s 0.35s ease both; }
    .fade-up-4 { animation: fadeUp 0.7s 0.5s ease both; }
    .pulse-dot  { animation: pulse 2s infinite; }
    .gold-shimmer {
      background: linear-gradient(90deg, #c9a84c 0%, #f0d080 40%, #c9a84c 60%, #e8c060 100%);
      background-size: 200% auto;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      animation: shimmer 3s linear infinite;
    }
  `}</style>;
// ─── ICONS ────────────────────────────────────────────────────
const IconWhatsApp = ({
  size = 22
}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" data-id="element-25">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" data-id="element-26" />
    <path d="M12 0C5.373 0 0 5.373 0 12c0 2.115.549 4.103 1.515 5.828L.057 23.803a.5.5 0 00.641.641l5.975-1.458A11.944 11.944 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.96 0-3.805-.528-5.391-1.448l-.387-.228-4.013.98.999-3.878-.251-.406A9.956 9.956 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z" data-id="element-27" />
  </svg>;
// ─── NAV ──────────────────────────────────────────────────────
const Navbar = ({
  onAdminClick
}) => <nav style={{
  background: 'rgba(10,22,40,0.97)',
  backdropFilter: 'blur(12px)',
  borderBottom: '1px solid rgba(201,168,76,0.15)',
  padding: '0 2rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  height: 68,
  position: 'sticky',
  top: 0,
  zIndex: 100
}} data-id="element-28">
    <div data-id="element-29">
      <div style={{
      fontFamily: "'Cormorant Garamond', serif",
      fontSize: '1.15rem',
      fontWeight: 700,
      color: '#c9a84c',
      letterSpacing: '0.5px'
    }} data-id="element-30">
        SunRoute Mobility Group LLC
      </div>
      <div style={{
      fontSize: '0.62rem',
      color: 'rgba(255,255,255,0.45)',
      letterSpacing: '2.5px',
      textTransform: 'uppercase',
      fontFamily: "'Outfit', sans-serif",
      fontWeight: 300
    }} data-id="element-31">
        Orlando, Florida
      </div>
    </div>
    <div style={{
    display: 'flex',
    alignItems: 'center',
    gap: '0.6rem'
  }} data-id="element-32">
      <button onClick={onAdminClick} style={{
      background: 'transparent',
      border: '1px solid rgba(201,168,76,0.4)',
      color: 'rgba(201,168,76,0.8)',
      padding: '0.45rem 0.9rem',
      borderRadius: 4,
      fontSize: '0.75rem',
      cursor: 'pointer',
      fontFamily: "'Outfit', sans-serif",
      letterSpacing: '1px'
    }} data-id="element-33">
        ADMIN
      </button>
      <a href={`https://wa.me/${WHATSAPP}?text=${WA_MSG}`} target="_blank" rel="noreferrer" style={{
      background: '#c9a84c',
      color: '#0a1628',
      padding: '0.5rem 1.2rem',
      borderRadius: 4,
      fontWeight: 600,
      fontSize: '0.82rem',
      cursor: 'pointer',
      fontFamily: "'Outfit', sans-serif",
      textDecoration: 'none',
      letterSpacing: '0.5px'
    }} data-id="element-34">
        Book Now
      </a>
    </div>
  </nav>;
// ─── HERO ─────────────────────────────────────────────────────
const Hero = () => <section style={{
  background: 'linear-gradient(160deg, #0a1628 0%, #0f2040 60%, #0a1628 100%)',
  padding: '5rem 2rem 4rem',
  position: 'relative',
  overflow: 'hidden'
}} data-id="element-35">
    {[{
    w: 380,
    h: 380,
    top: -80,
    right: -80,
    op: 0.06
  }, {
    w: 220,
    h: 220,
    bottom: -60,
    left: -40,
    op: 0.04
  }].map((r, i) => <div key={i} style={{
    position: 'absolute',
    width: r.w,
    height: r.h,
    top: r.top,
    bottom: r.bottom,
    left: r.left,
    right: r.right,
    borderRadius: '50%',
    border: `1px solid rgba(201,168,76,${r.op * 3})`,
    background: `radial-gradient(circle, rgba(201,168,76,${r.op}) 0%, transparent 70%)`,
    pointerEvents: 'none'
  }} data-id="element-36" />)}
    <div style={{
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'repeating-linear-gradient(45deg, rgba(201,168,76,0.015) 0px, rgba(201,168,76,0.015) 1px, transparent 1px, transparent 60px)',
    pointerEvents: 'none'
  }} data-id="element-37" />
    <div style={{
    position: 'relative',
    maxWidth: 600
  }} data-id="element-38">
      <div className="fade-up" style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 8,
      background: 'rgba(201,168,76,0.1)',
      border: '1px solid rgba(201,168,76,0.25)',
      color: '#c9a84c',
      fontSize: '0.68rem',
      letterSpacing: '2.5px',
      textTransform: 'uppercase',
      padding: '0.4rem 1rem',
      borderRadius: 20,
      marginBottom: '1.5rem',
      fontFamily: "'Outfit', sans-serif"
    }} data-id="element-39">
        <span className="pulse-dot" style={{
        width: 6,
        height: 6,
        borderRadius: '50%',
        background: '#22c55e',
        display: 'inline-block'
      }} data-id="element-40" />
        Available Now · Orlando, FL
      </div>
      <h1 className="fade-up-1" style={{
      fontFamily: "'Cormorant Garamond', serif",
      fontSize: 'clamp(2.4rem, 6vw, 3.8rem)',
      fontWeight: 900,
      lineHeight: 1.1,
      color: '#fff',
      marginBottom: '1.2rem'
    }} data-id="element-41">
        Explore Orlando
        <br data-id="element-42" />
        <span className="gold-shimmer" data-id="element-43">On Your Schedule</span>
      </h1>
      <p className="fade-up-2" style={{
      color: 'rgba(255,255,255,0.6)',
      fontSize: '1rem',
      lineHeight: 1.75,
      maxWidth: 480,
      marginBottom: '2rem',
      fontWeight: 300
    }} data-id="element-44">
        Premium sedan rental for tourists and business travelers. Airport
        delivery to MCO included. Disney, Universal & beyond — all within reach.
      </p>
      <div className="fade-up-3" style={{
      display: 'flex',
      gap: '0.75rem',
      flexWrap: 'wrap'
    }} data-id="element-45">
        <a href={`https://wa.me/${WHATSAPP}?text=${WA_MSG}`} target="_blank" rel="noreferrer" style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 10,
        background: '#25d366',
        color: '#fff',
        padding: '0.85rem 1.8rem',
        borderRadius: 5,
        fontWeight: 600,
        fontSize: '0.95rem',
        textDecoration: 'none',
        fontFamily: "'Outfit', sans-serif"
      }} data-id="element-46">
          <IconWhatsApp size={20} data-id="element-47" />
          Reserve on WhatsApp
        </a>
        <a href="https://turo.com" target="_blank" rel="noreferrer" style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        background: 'transparent',
        color: 'rgba(255,255,255,0.75)',
        padding: '0.85rem 1.6rem',
        borderRadius: 5,
        fontWeight: 400,
        fontSize: '0.9rem',
        border: '1px solid rgba(255,255,255,0.2)',
        textDecoration: 'none',
        fontFamily: "'Outfit', sans-serif"
      }} data-id="element-48">
          View on Turo →
        </a>
      </div>
    </div>
  </section>;
// ─── PRICE STRIP ──────────────────────────────────────────────
const PriceStrip = () => <div style={{
  background: '#c9a84c',
  padding: '1.2rem 2rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  gap: '1rem'
}} data-id="element-49">
    <div data-id="element-50">
      <div style={{
      fontFamily: "'Cormorant Garamond', serif",
      fontSize: '2.6rem',
      fontWeight: 900,
      color: '#0a1628',
      lineHeight: 1
    }} data-id="element-51">
        $60
        <span style={{
        fontFamily: "'Outfit', sans-serif",
        fontSize: '1rem',
        fontWeight: 400,
        marginLeft: 4
      }} data-id="element-52">
          / day
        </span>
      </div>
      <div style={{
      fontSize: '0.8rem',
      color: 'rgba(10,22,40,0.65)',
      marginTop: 2
    }} data-id="element-53">
        $100 refundable deposit · MCO Airport delivery available
      </div>
    </div>
    <div style={{
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    background: '#0a1628',
    color: '#c9a84c',
    padding: '0.5rem 1.1rem',
    borderRadius: 4,
    fontSize: '0.8rem',
    fontWeight: 600,
    letterSpacing: '0.5px'
  }} data-id="element-54">
      <span className="pulse-dot" style={{
      width: 8,
      height: 8,
      borderRadius: '50%',
      background: '#22c55e',
      display: 'inline-block'
    }} data-id="element-55" />
      AVAILABLE NOW
    </div>
  </div>;
// ─── CAR SECTION ──────────────────────────────────────────────
const CarSection = () => {
  const specs = [['Year', '2017'], ['Model', 'Ford Fusion SE'], ['Body', 'Sedan'], ['Seats', '5 Passengers'], ['Transmission', 'Automatic'], ['A/C', 'Full Climate Control'], ['Fuel', 'Gasoline'], ['Doors', '4 Doors']];
  return <section style={{
    background: '#f5f1e8',
    padding: '3rem 2rem'
  }} data-id="element-56">
      <div style={{
      maxWidth: 640,
      margin: '0 auto'
    }} data-id="element-57">
        <p style={{
        fontSize: '0.68rem',
        letterSpacing: '3px',
        color: '#c9a84c',
        textTransform: 'uppercase',
        marginBottom: '0.4rem',
        fontWeight: 600
      }} data-id="element-58">
          Your Vehicle
        </p>
        <h2 style={{
        fontFamily: "'Cormorant Garamond', serif",
        fontSize: '2rem',
        fontWeight: 700,
        color: '#0a1628',
        marginBottom: '1.5rem'
      }} data-id="element-59">
          2017 Ford Fusion SE
        </h2>
        <CarCarousel data-id="element-60" />
        <div style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '0.6rem'
      }} data-id="element-61">
          {specs.map(([label, val]) => <div key={label} style={{
          background: '#fff',
          borderRadius: 8,
          padding: '0.75rem 1rem',
          borderLeft: '3px solid #c9a84c'
        }} data-id="element-62">
              <div style={{
            fontSize: '0.65rem',
            color: '#94a3b8',
            textTransform: 'uppercase',
            letterSpacing: '1px',
            marginBottom: 3
          }} data-id="element-63">
                {label}
              </div>
              <div style={{
            fontSize: '0.9rem',
            fontWeight: 600,
            color: '#0a1628'
          }} data-id="element-64">
                {val}
              </div>
            </div>)}
        </div>
        <div style={{
        marginTop: '1.2rem',
        background: '#fff',
        border: '1px solid #e2e8f0',
        borderRadius: 8,
        padding: '1rem 1.2rem',
        display: 'flex',
        gap: '0.75rem',
        alignItems: 'flex-start'
      }} data-id="element-65">
          <span style={{
          fontSize: '1.3rem',
          marginTop: 2
        }} data-id="element-66">
            🛡️
          </span>
          <div data-id="element-67">
            <div style={{
            fontSize: '0.85rem',
            fontWeight: 600,
            color: '#0a1628',
            marginBottom: 3
          }} data-id="element-68">
              $100 Refundable Security Deposit
            </div>
            <div style={{
            fontSize: '0.78rem',
            color: '#64748b',
            lineHeight: 1.6
          }} data-id="element-69">
              Required at reservation. Fully returned after vehicle inspection
              at end of rental. Renter must provide their own insurance
              coverage.
            </div>
          </div>
        </div>
      </div>
    </section>;
};
// ─── FEATURES ─────────────────────────────────────────────────
const Features = () => {
  const feats = [{
    icon: '✈️',
    title: 'MCO Airport Delivery',
    desc: 'We bring the car directly to Orlando International Airport — start your trip the moment you land.'
  }, {
    icon: '🏰',
    title: 'Theme Park Access',
    desc: "Minutes from Walt Disney World, Universal Studios, SeaWorld and all of Orlando's top attractions."
  }, {
    icon: '💼',
    title: 'Business & Leisure',
    desc: 'Perfect for both corporate travel and family vacations. Clean, comfortable and reliable.'
  }, {
    icon: '💬',
    title: 'WhatsApp Booking',
    desc: 'No complicated forms. Message us directly and get a confirmed reservation in minutes.'
  }, {
    icon: '💵',
    title: 'Best Rate in Town',
    desc: 'Only $60/day — transparent pricing, no hidden fees, no surprise charges at drop-off.'
  }, {
    icon: '🚗',
    title: 'Also on Turo',
    desc: 'Find and review us on the Turo platform for added booking convenience and peace of mind.'
  }];
  return <section style={{
    background: '#fff',
    padding: '3rem 2rem'
  }} data-id="element-70">
      <div style={{
      maxWidth: 640,
      margin: '0 auto'
    }} data-id="element-71">
        <p style={{
        fontSize: '0.68rem',
        letterSpacing: '3px',
        color: '#c9a84c',
        textTransform: 'uppercase',
        marginBottom: '0.4rem',
        fontWeight: 600
      }} data-id="element-72">
          Why Choose Us
        </p>
        <h2 style={{
        fontFamily: "'Cormorant Garamond', serif",
        fontSize: '2rem',
        fontWeight: 700,
        color: '#0a1628',
        marginBottom: '1.5rem'
      }} data-id="element-73">
          The SunRoute Experience
        </h2>
        <div style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '0.85rem'
      }} data-id="element-74">
          {feats.map(f => <div key={f.title} style={{
          background: '#f8f6f0',
          borderRadius: 10,
          padding: '1.2rem',
          borderTop: '3px solid #c9a84c'
        }} data-id="element-75">
              <div style={{
            fontSize: '1.6rem',
            marginBottom: '0.5rem'
          }} data-id="element-76">
                {f.icon}
              </div>
              <div style={{
            fontSize: '0.85rem',
            fontWeight: 600,
            color: '#0a1628',
            marginBottom: '0.3rem'
          }} data-id="element-77">
                {f.title}
              </div>
              <div style={{
            fontSize: '0.76rem',
            color: '#64748b',
            lineHeight: 1.6
          }} data-id="element-78">
                {f.desc}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};
// ─── PUBLIC AVAILABILITY SECTION ──────────────────────────────
const PublicCalendarSection = () => <section style={{
  background: '#f5f1e8',
  padding: '3rem 2rem'
}} data-id="element-79">
    <div style={{
    maxWidth: 640,
    margin: '0 auto'
  }} data-id="element-80">
      <p style={{
      fontSize: '0.68rem',
      letterSpacing: '3px',
      color: '#c9a84c',
      textTransform: 'uppercase',
      marginBottom: '0.4rem',
      fontWeight: 600
    }} data-id="element-81">
        Live Availability
      </p>
      <h2 style={{
      fontFamily: "'Cormorant Garamond', serif",
      fontSize: '2rem',
      fontWeight: 700,
      color: '#0a1628',
      marginBottom: '0.5rem'
    }} data-id="element-82">
        Check the Calendar
      </h2>
      <p style={{
      color: '#64748b',
      fontSize: '0.9rem',
      marginBottom: '1.2rem',
      lineHeight: 1.6
    }} data-id="element-83">
        See available dates for the 2017 Ford Fusion SE. Updated directly by our
        team.
      </p>
      <div style={{
      background: '#fff',
      borderRadius: 12,
      border: '1px solid #e2e8f0',
      overflow: 'hidden',
      boxShadow: '0 2px 12px rgba(10,22,40,0.06)'
    }} data-id="element-84">
        <div style={{
        background: '#0a1628',
        padding: '0.85rem 1.2rem',
        color: '#c9a84c',
        fontSize: '0.85rem',
        fontWeight: 600,
        display: 'flex',
        alignItems: 'center',
        gap: 8
      }} data-id="element-85">
          📅 2017 Ford Fusion SE · $60/day
        </div>
        <Calendar vehicleName="2017 Ford Fusion SE" readOnly data-id="element-86" />
      </div>
      <div style={{
      marginTop: '1rem',
      textAlign: 'center'
    }} data-id="element-87">
        <a href={`https://wa.me/${WHATSAPP}?text=${WA_MSG}`} target="_blank" rel="noreferrer" style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        background: '#25d366',
        color: '#fff',
        padding: '0.7rem 1.5rem',
        borderRadius: 5,
        fontWeight: 600,
        fontSize: '0.85rem',
        textDecoration: 'none',
        fontFamily: "'Outfit', sans-serif"
      }} data-id="element-88">
          <IconWhatsApp size={18} data-id="element-89" />
          Reserve Available Dates
        </a>
      </div>
    </div>
  </section>;
// ─── CTA ──────────────────────────────────────────────────────
const CTASection = () => <section style={{
  background: 'linear-gradient(160deg, #0a1628 0%, #0f2040 100%)',
  padding: '4rem 2rem',
  textAlign: 'center',
  position: 'relative',
  overflow: 'hidden'
}} data-id="element-90">
    <div style={{
    position: 'absolute',
    inset: 0,
    background: 'repeating-linear-gradient(45deg, rgba(201,168,76,0.015) 0px, rgba(201,168,76,0.015) 1px, transparent 1px, transparent 50px)'
  }} data-id="element-91" />
    <div style={{
    position: 'relative'
  }} data-id="element-92">
      <p style={{
      fontSize: '0.68rem',
      letterSpacing: '3px',
      color: '#c9a84c',
      textTransform: 'uppercase',
      marginBottom: '0.75rem',
      fontWeight: 600
    }} data-id="element-93">
        Ready to Go?
      </p>
      <h2 style={{
      fontFamily: "'Cormorant Garamond', serif",
      fontSize: 'clamp(1.8rem, 5vw, 2.8rem)',
      fontWeight: 700,
      color: '#fff',
      marginBottom: '0.75rem',
      lineHeight: 1.2
    }} data-id="element-94">
        Book Your Ride Today
      </h2>
      <p style={{
      color: 'rgba(255,255,255,0.55)',
      fontSize: '0.92rem',
      marginBottom: '2rem',
      maxWidth: 380,
      margin: '0 auto 2rem'
    }} data-id="element-95">
        Message us on WhatsApp to confirm availability and lock in your dates
        instantly.
      </p>
      <a href={`https://wa.me/${WHATSAPP}?text=${WA_MSG}`} target="_blank" rel="noreferrer" style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 12,
      background: '#25d366',
      color: '#fff',
      padding: '1.1rem 2.4rem',
      borderRadius: 6,
      fontWeight: 700,
      fontSize: '1.05rem',
      textDecoration: 'none',
      fontFamily: "'Outfit', sans-serif"
    }} data-id="element-96">
        <IconWhatsApp size={22} data-id="element-97" />
        +1 (321) 332-5840
      </a>
      <p style={{
      color: 'rgba(255,255,255,0.3)',
      fontSize: '0.75rem',
      marginTop: '0.9rem'
    }} data-id="element-98">
        Available 7 days a week · Fast response guaranteed
      </p>
      <div style={{
      marginTop: '2.5rem',
      paddingTop: '1.5rem',
      borderTop: '1px solid rgba(255,255,255,0.08)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '1.5rem',
      flexWrap: 'wrap'
    }} data-id="element-99">
        <span style={{
        color: 'rgba(255,255,255,0.35)',
        fontSize: '0.78rem'
      }} data-id="element-100">
          Also find us on
        </span>
        <a href="https://turo.com" target="_blank" rel="noreferrer" style={{
        background: '#1a56db',
        color: '#fff',
        padding: '0.35rem 0.9rem',
        borderRadius: 4,
        fontWeight: 700,
        fontSize: '0.8rem',
        textDecoration: 'none',
        letterSpacing: '1px'
      }} data-id="element-101">
          TURO
        </a>
        <span style={{
        color: 'rgba(255,255,255,0.35)',
        fontSize: '0.78rem'
      }} data-id="element-102">
          ·
        </span>
        <a href="mailto:sunroutemobilitygroupllc@outlook.com" style={{
        color: 'rgba(201,168,76,0.7)',
        fontSize: '0.78rem',
        textDecoration: 'none'
      }} data-id="element-103">
          sunroutemobilitygroupllc@outlook.com
        </a>
      </div>
    </div>
  </section>;
// ─── FOOTER ───────────────────────────────────────────────────
const Footer = ({
  onOpenLegal
}) => <footer style={{
  background: '#060e1c',
  padding: '1.6rem 2rem 1.4rem',
  borderTop: '1px solid rgba(201,168,76,0.12)'
}} data-id="element-104">
    <div style={{
    maxWidth: 720,
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '0.8rem'
  }} data-id="element-105">
      <div style={{
      display: 'flex',
      gap: '1.5rem',
      flexWrap: 'wrap',
      justifyContent: 'center'
    }} data-id="element-106">
        <button onClick={() => onOpenLegal('terms')} style={{
        background: 'none',
        border: 'none',
        color: 'rgba(201,168,76,0.85)',
        fontSize: '0.78rem',
        cursor: 'pointer',
        fontFamily: "'Outfit', sans-serif",
        letterSpacing: '0.5px',
        textDecoration: 'none',
        padding: 0
      }} data-id="element-107">
          Terms & Conditions
        </button>
        <span style={{
        color: 'rgba(255,255,255,0.2)',
        fontSize: '0.78rem'
      }} data-id="element-108">
          ·
        </span>
        <button onClick={() => onOpenLegal('privacy')} style={{
        background: 'none',
        border: 'none',
        color: 'rgba(201,168,76,0.85)',
        fontSize: '0.78rem',
        cursor: 'pointer',
        fontFamily: "'Outfit', sans-serif",
        letterSpacing: '0.5px',
        textDecoration: 'none',
        padding: 0
      }} data-id="element-109">
          Privacy Policy
        </button>
      </div>
      <div style={{
      color: 'rgba(255,255,255,0.25)',
      fontSize: '0.72rem',
      textAlign: 'center'
    }} data-id="element-110">
        © 2025 SunRoute Mobility Group LLC · Orlando, Florida ·
        sunroutemobilitygroup.com
      </div>
    </div>
  </footer>;
// ─── LOGIN MODAL ──────────────────────────────────────────────
const LoginModal = ({
  onSuccess,
  onClose
}) => {
  const [user, setUser] = useState('');
  const [pass, setPass] = useState('');
  const [error, setError] = useState(false);
  const submit = () => {
    if (user === ADMIN_USER && pass === ADMIN_PASS) {
      onSuccess();
    } else {
      setError(true);
      setTimeout(() => setError(false), 2000);
    }
  };
  return <div style={{
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.75)',
    zIndex: 999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }} data-id="element-111">
      <div style={{
      background: '#fff',
      borderRadius: 14,
      padding: '2rem',
      width: 320,
      maxWidth: '92vw',
      boxShadow: '0 24px 60px rgba(0,0,0,0.4)'
    }} data-id="element-112">
        <div style={{
        fontFamily: "'Cormorant Garamond', serif",
        fontSize: '1.4rem',
        fontWeight: 700,
        color: '#0a1628',
        marginBottom: 4
      }} data-id="element-113">
          Admin Access
        </div>
        <div style={{
        fontSize: '0.78rem',
        color: '#94a3b8',
        marginBottom: '1.4rem'
      }} data-id="element-114">
          SunRoute Mobility Group LLC
        </div>
        {[['Username', user, setUser, 'text', 'admin'], ['Password', pass, setPass, 'password', '••••••••']].map(([label, val, set, type, ph]) => <div key={label} style={{
        marginBottom: '0.9rem'
      }} data-id="element-115">
            <div style={{
          fontSize: '0.68rem',
          color: '#94a3b8',
          textTransform: 'uppercase',
          letterSpacing: '1px',
          marginBottom: 5
        }} data-id="element-116">
              {label}
            </div>
            <input type={type} value={val} placeholder={ph} onChange={e => set(e.target.value)} onKeyDown={e => e.key === 'Enter' && submit()} style={{
          width: '100%',
          border: '1px solid #e2e8f0',
          borderRadius: 5,
          padding: '0.65rem 0.85rem',
          fontSize: '0.9rem',
          fontFamily: "'Outfit', sans-serif",
          color: '#0a1628',
          outline: 'none'
        }} data-id="element-117" />
          </div>)}
        {error && <div style={{
        color: '#ef4444',
        fontSize: '0.75rem',
        textAlign: 'center',
        marginBottom: '0.6rem'
      }} data-id="element-118">
            Invalid credentials
          </div>}
        <button onClick={submit} style={{
        width: '100%',
        background: '#0a1628',
        color: '#c9a84c',
        border: 'none',
        padding: '0.8rem',
        borderRadius: 5,
        fontWeight: 700,
        fontSize: '0.9rem',
        cursor: 'pointer',
        fontFamily: "'Outfit', sans-serif",
        marginBottom: '0.6rem'
      }} data-id="element-119">
          Enter Dashboard
        </button>
        <button onClick={onClose} style={{
        width: '100%',
        background: 'none',
        border: 'none',
        color: '#94a3b8',
        fontSize: '0.8rem',
        cursor: 'pointer',
        fontFamily: "'Outfit', sans-serif"
      }} data-id="element-120">
          Cancel
        </button>
      </div>
    </div>;
};
// ─── CALENDAR ─────────────────────────────────────────────────
// Status values: "available" (default/cleared), "booked", "blocked"
const STATUS_STYLES = {
  available: {
    bg: '#e8f5e9',
    color: '#2e7d32',
    label: 'Available',
    swatch: '#c8e6c9'
  },
  booked: {
    bg: '#fce4ec',
    color: '#c62828',
    label: 'Booked',
    swatch: '#ef5350'
  },
  blocked: {
    bg: '#e2e8f0',
    color: '#475569',
    label: 'Blocked',
    swatch: '#94a3b8'
  }
};
const Calendar = ({
  vehicleName,
  readOnly = false,
  onSelectionChange
}) => {
  const today = new Date();
  const [year, setYear] = useState(today.getFullYear());
  const [month, setMonth] = useState(today.getMonth());
  const [mode, setMode] = useState('booked'); // active brush: 'available' | 'booked' | 'blocked'
  const [statuses, setStatuses] = useState(() => {
    try {
      const saved = localStorage.getItem('srmg_bookings');
      if (!saved) return {};
      const parsed = JSON.parse(saved);
      // migrate old boolean shape -> "booked"
      const migrated = {};
      Object.entries(parsed).forEach(([k, v]) => {
        if (v === true) migrated[k] = 'booked';else if (typeof v === 'string') migrated[k] = v;
      });
      return migrated;
    } catch {
      return {};
    }
  });
  const firstDay = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const applyDay = d => {
    const key = `${year}-${month + 1}-${d}`;
    setStatuses(prev => {
      const current = prev[key] || 'available';
      const next = {
        ...prev
      };
      // if applying the same status again, clear back to available
      if (current === mode || mode === 'available') {
        delete next[key];
      } else {
        next[key] = mode;
      }
      try {
        localStorage.setItem('srmg_bookings', JSON.stringify(next));
      } catch {}
      if (onSelectionChange) onSelectionChange(next);
      return next;
    });
  };
  const prevMonth = () => {
    if (month === 0) {
      setMonth(11);
      setYear(y => y - 1);
    } else setMonth(m => m - 1);
  };
  const nextMonth = () => {
    if (month === 11) {
      setMonth(0);
      setYear(y => y + 1);
    } else setMonth(m => m + 1);
  };
  const bookedCount = Object.values(statuses).filter(s => s === 'booked').length;
  const blockedCount = Object.values(statuses).filter(s => s === 'blocked').length;
  return <div data-id="element-121">
      <div style={{
      padding: '1rem 1.2rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    }} data-id="element-122">
        <button onClick={prevMonth} style={{
        background: 'none',
        border: '1px solid #e2e8f0',
        borderRadius: 4,
        padding: '0.3rem 0.7rem',
        cursor: 'pointer',
        fontSize: '0.85rem',
        color: '#0a1628'
      }} data-id="element-123">
          ‹
        </button>
        <div style={{
        fontWeight: 600,
        fontSize: '0.9rem',
        color: '#0a1628'
      }} data-id="element-124">
          {MONTHS[month]} {year}
        </div>
        <button onClick={nextMonth} style={{
        background: 'none',
        border: '1px solid #e2e8f0',
        borderRadius: 4,
        padding: '0.3rem 0.7rem',
        cursor: 'pointer',
        fontSize: '0.85rem',
        color: '#0a1628'
      }} data-id="element-125">
          ›
        </button>
      </div>
      {/* Mode selector — hidden in readOnly */}
      {!readOnly && <div style={{
      padding: '0 1.2rem 0.9rem',
      display: 'flex',
      gap: 6,
      flexWrap: 'wrap'
    }} data-id="element-126">
          {['available', 'booked', 'blocked'].map(m => {
        const s = STATUS_STYLES[m];
        const isActive = mode === m;
        return <button key={m} onClick={() => setMode(m)} style={{
          flex: '1 1 0',
          minWidth: 80,
          padding: '0.5rem 0.6rem',
          borderRadius: 6,
          fontSize: '0.75rem',
          fontWeight: 600,
          cursor: 'pointer',
          fontFamily: "'Outfit', sans-serif",
          background: isActive ? s.color : '#fff',
          color: isActive ? '#fff' : s.color,
          border: `1.5px solid ${s.color}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 6,
          transition: 'all 0.15s'
        }} data-id="element-127">
                <span style={{
            width: 10,
            height: 10,
            borderRadius: 2,
            background: isActive ? '#fff' : s.swatch,
            display: 'inline-block'
          }} data-id="element-128" />
                {s.label}
              </button>;
      })}
        </div>}
      {!readOnly && <div style={{
      padding: '0 1.2rem 0.5rem',
      fontSize: '0.7rem',
      color: '#64748b',
      fontStyle: 'italic'
    }} data-id="element-129">
          {`Active brush: ${STATUS_STYLES[mode].label}. Click a date to apply (click again to clear).`}
        </div>}
      <div style={{
      padding: '0 1.2rem 1rem'
    }} data-id="element-130">
        <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(7, 1fr)',
        gap: 3,
        marginBottom: 4
      }} data-id="element-131">
          {DAY_NAMES.map(d => <div key={d} style={{
          textAlign: 'center',
          fontSize: '0.62rem',
          color: '#94a3b8',
          padding: '0.3rem 0',
          textTransform: 'uppercase',
          letterSpacing: '0.5px'
        }} data-id="element-132">
              {d}
            </div>)}
        </div>
        <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(7, 1fr)',
        gap: 3
      }} data-id="element-133">
          {Array.from({
          length: firstDay
        }).map((_, i) => <div key={`e${i}`} data-id="element-134" />)}
          {Array.from({
          length: daysInMonth
        }).map((_, i) => {
          const d = i + 1;
          const key = `${year}-${month + 1}-${d}`;
          const status = statuses[key] || 'available';
          const s = STATUS_STYLES[status];
          const isToday = today.getFullYear() === year && today.getMonth() === month && today.getDate() === d;
          const clickable = !readOnly;
          return <div key={d} onClick={() => clickable && applyDay(d)} title={`${MONTHS[month]} ${d} · ${s.label}`} style={{
            textAlign: 'center',
            padding: '0.45rem 0',
            borderRadius: 5,
            fontSize: '0.78rem',
            cursor: clickable ? 'pointer' : 'default',
            fontWeight: isToday ? 700 : 500,
            background: s.bg,
            color: s.color,
            border: isToday ? '2px solid #c9a84c' : '1px solid transparent',
            transition: 'transform 0.1s, background 0.15s'
          }} data-id="element-135">
                {d}
              </div>;
        })}
        </div>
      </div>
      <div style={{
      padding: '0.75rem 1.2rem',
      borderTop: '1px solid #e2e8f0',
      display: 'flex',
      gap: '1.2rem',
      alignItems: 'center',
      flexWrap: 'wrap'
    }} data-id="element-136">
        {[['#c8e6c9', '#2e7d32', 'Available'], ['#ef5350', '#c62828', 'Booked'], ['#94a3b8', '#475569', 'Blocked'], ['transparent', '#c9a84c', 'Today']].map(([bg, col, label]) => <div key={label} style={{
        display: 'flex',
        alignItems: 'center',
        gap: 5
      }} data-id="element-137">
            <div style={{
          width: 10,
          height: 10,
          borderRadius: 2,
          background: bg,
          border: bg === 'transparent' ? `2px solid ${col}` : 'none'
        }} data-id="element-138" />
            <span style={{
          fontSize: '0.72rem',
          color: '#64748b'
        }} data-id="element-139">
              {label}
            </span>
          </div>)}
        <span style={{
        marginLeft: 'auto',
        fontSize: '0.72rem',
        color: '#64748b'
      }} data-id="element-140">
          {bookedCount} booked · {blockedCount} blocked · Est. $
          {(bookedCount * 60).toLocaleString()}
        </span>
      </div>
    </div>;
};
// ─── ADMIN PANEL ──────────────────────────────────────────────
const AdminPanel = ({
  onBack
}) => {
  const [vehicles, setVehicles] = useState([{
    id: 1,
    name: '2017 Ford Fusion SE',
    rate: 60,
    plate: '',
    available: true
  }]);
  const [newV, setNewV] = useState({
    year: '',
    model: '',
    rate: '',
    plate: ''
  });
  const toggleAvail = id => setVehicles(v => v.map(x => x.id === id ? {
    ...x,
    available: !x.available
  } : x));
  const addVehicle = () => {
    if (!newV.year || !newV.model) return;
    setVehicles(v => [...v, {
      id: Date.now(),
      name: `${newV.year} ${newV.model}`,
      rate: parseInt(newV.rate) || 60,
      plate: newV.plate,
      available: true
    }]);
    setNewV({
      year: '',
      model: '',
      rate: '',
      plate: ''
    });
  };
  const cardStyle = {
    background: '#fff',
    borderRadius: 10,
    border: '1px solid #e2e8f0',
    marginBottom: '1.1rem',
    overflow: 'hidden'
  };
  const cardHead = {
    background: '#0a1628',
    padding: '0.75rem 1.2rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  };
  const cardHeadText = {
    color: '#fff',
    fontSize: '0.85rem',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    gap: 6
  };
  return <div style={{
    background: '#f5f1e8',
    minHeight: '100vh',
    padding: '1.5rem'
  }} data-id="element-141">
      <div style={{
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      marginBottom: '1.5rem'
    }} data-id="element-142">
        <div data-id="element-143">
          <h2 style={{
          fontFamily: "'Cormorant Garamond', serif",
          fontSize: '1.5rem',
          fontWeight: 700,
          color: '#0a1628'
        }} data-id="element-144">
            Admin Dashboard
          </h2>
          <p style={{
          fontSize: '0.75rem',
          color: '#94a3b8',
          marginTop: 2
        }} data-id="element-145">
            SunRoute Mobility Group LLC
          </p>
        </div>
        <button onClick={onBack} style={{
        background: '#0a1628',
        color: '#fff',
        border: 'none',
        padding: '0.5rem 1rem',
        borderRadius: 4,
        cursor: 'pointer',
        fontFamily: "'Outfit', sans-serif",
        fontSize: '0.78rem'
      }} data-id="element-146">
          ← Back to Site
        </button>
      </div>

      <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(3,1fr)',
      gap: '0.75rem',
      marginBottom: '1.2rem'
    }} data-id="element-147">
        {[['Fleet', vehicles.length], ['Available', vehicles.filter(v => v.available).length], ['Daily Potential', `$${vehicles.filter(v => v.available).reduce((s, v) => s + v.rate, 0)}`]].map(([label, val]) => <div key={label} style={{
        background: '#fff',
        borderRadius: 8,
        padding: '1rem',
        border: '1px solid #e2e8f0',
        textAlign: 'center'
      }} data-id="element-148">
            <div style={{
          fontFamily: "'Cormorant Garamond', serif",
          fontSize: '1.8rem',
          fontWeight: 700,
          color: '#0a1628'
        }} data-id="element-149">
              {val}
            </div>
            <div style={{
          fontSize: '0.68rem',
          color: '#94a3b8',
          textTransform: 'uppercase',
          letterSpacing: '1px'
        }} data-id="element-150">
              {label}
            </div>
          </div>)}
      </div>

      <div style={cardStyle} data-id="element-151">
        <div style={cardHead} data-id="element-152">
          <span style={cardHeadText} data-id="element-153">🚗 Fleet Management</span>
        </div>
        {vehicles.map(v => <div key={v.id} style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0.9rem 1.2rem',
        borderBottom: '1px solid #f1f5f9',
        flexWrap: 'wrap',
        gap: '0.5rem'
      }} data-id="element-154">
            <div data-id="element-155">
              <div style={{
            fontSize: '0.85rem',
            fontWeight: 600,
            color: '#0a1628'
          }} data-id="element-156">
                {v.name}
              </div>
              <div style={{
            fontSize: '0.72rem',
            color: '#94a3b8'
          }} data-id="element-157">
                ${v.rate}/day · Plate: {v.plate || '—'}
              </div>
            </div>
            <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8
        }} data-id="element-158">
              <div onClick={() => toggleAvail(v.id)} style={{
            width: 44,
            height: 24,
            borderRadius: 12,
            background: v.available ? '#22c55e' : '#cbd5e1',
            position: 'relative',
            cursor: 'pointer',
            transition: 'background 0.3s'
          }} data-id="element-159">
                <div style={{
              width: 18,
              height: 18,
              borderRadius: '50%',
              background: '#fff',
              position: 'absolute',
              top: 3,
              left: v.available ? 23 : 3,
              transition: 'left 0.3s'
            }} data-id="element-160" />
              </div>
              <span style={{
            fontSize: '0.72rem',
            color: v.available ? '#16a34a' : '#94a3b8'
          }} data-id="element-161">
                {v.available ? 'Available' : 'Unavailable'}
              </span>
            </div>
          </div>)}
        <div style={{
        padding: '1rem 1.2rem',
        borderTop: '1px solid #f1f5f9'
      }} data-id="element-162">
          <p style={{
          fontSize: '0.68rem',
          color: '#94a3b8',
          textTransform: 'uppercase',
          letterSpacing: '1px',
          marginBottom: '0.75rem',
          fontWeight: 600
        }} data-id="element-163">
            Add Future Vehicle
          </p>
          <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '0.6rem'
        }} data-id="element-164">
            {[['Year', 'year', 'text', '2020'], ['Make & Model', 'model', 'text', 'Toyota Camry LE'], ['Daily Rate ($)', 'rate', 'number', '65'], ['License Plate', 'plate', 'text', 'ABC-1234']].map(([label, field, type, ph]) => <div key={field} data-id="element-165">
                <div style={{
              fontSize: '0.65rem',
              color: '#94a3b8',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              marginBottom: 4
            }} data-id="element-166">
                  {label}
                </div>
                <input type={type} placeholder={ph} value={newV[field]} onChange={e => setNewV(p => ({
              ...p,
              [field]: e.target.value
            }))} style={{
              width: '100%',
              border: '1px solid #e2e8f0',
              borderRadius: 4,
              padding: '0.5rem 0.75rem',
              fontSize: '0.82rem',
              fontFamily: "'Outfit', sans-serif",
              color: '#0a1628'
            }} data-id="element-167" />
              </div>)}
            <button onClick={addVehicle} style={{
            gridColumn: '1/-1',
            background: '#0a1628',
            color: '#c9a84c',
            border: 'none',
            padding: '0.7rem',
            borderRadius: 4,
            fontWeight: 600,
            cursor: 'pointer',
            fontFamily: "'Outfit', sans-serif",
            fontSize: '0.85rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 6
          }} data-id="element-168">
              + Add Vehicle to Fleet
            </button>
          </div>
        </div>
      </div>

      <div style={cardStyle} data-id="element-169">
        <div style={cardHead} data-id="element-170">
          <span style={cardHeadText} data-id="element-171">
            📅 Availability Calendar · 2017 Ford Fusion SE
          </span>
        </div>
        <Calendar vehicleName="2017 Ford Fusion SE" data-id="element-172" />
        <div style={{
        padding: '0.75rem 1.2rem',
        borderTop: '1px solid #e2e8f0'
      }} data-id="element-173">
          <p style={{
          fontSize: '0.72rem',
          color: '#94a3b8',
          lineHeight: 1.6
        }} data-id="element-174">
            Select{' '}
            <strong style={{
            color: '#c62828'
          }} data-id="element-175">
              Booked
            </strong>
            ,{' '}
            <strong style={{
            color: '#475569'
          }} data-id="element-176">
              Blocked
            </strong>
            , or{' '}
            <strong style={{
            color: '#2e7d32'
          }} data-id="element-177">
              Available
            </strong>
            , then click a date to apply the status. Click the same date again
            to clear it. Revenue estimated at $60/day per booked date.
          </p>
        </div>
      </div>

      <div style={cardStyle} data-id="element-178">
        <div style={cardHead} data-id="element-179">
          <span style={cardHeadText} data-id="element-180">📋 Booking Log</span>
        </div>
        {[{
        init: 'MG',
        name: 'Maria Garcia',
        dates: 'Jun 15–18 · 3 days',
        total: '$180 + deposit',
        status: 'confirmed'
      }, {
        init: 'JL',
        name: 'James Lee',
        dates: 'Jun 22–25 · 3 days',
        total: '$180 + deposit',
        status: 'pending'
      }].map(b => <div key={b.name} style={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
        padding: '0.85rem 1.2rem',
        borderBottom: '1px solid #f1f5f9'
      }} data-id="element-181">
            <div style={{
          width: 34,
          height: 34,
          borderRadius: '50%',
          background: '#0a1628',
          color: '#c9a84c',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '0.72rem',
          fontWeight: 700,
          flexShrink: 0
        }} data-id="element-182">
              {b.init}
            </div>
            <div style={{
          flex: 1
        }} data-id="element-183">
              <div style={{
            fontSize: '0.82rem',
            fontWeight: 600,
            color: '#0a1628'
          }} data-id="element-184">
                {b.name}
              </div>
              <div style={{
            fontSize: '0.72rem',
            color: '#94a3b8'
          }} data-id="element-185">
                {b.dates} · {b.total}
              </div>
            </div>
            <div style={{
          fontSize: '0.7rem',
          padding: '0.25rem 0.65rem',
          borderRadius: 12,
          fontWeight: 600,
          background: b.status === 'confirmed' ? '#e8f5e9' : '#fff8e1',
          color: b.status === 'confirmed' ? '#2e7d32' : '#f57f17'
        }} data-id="element-186">
              {b.status === 'confirmed' ? 'Confirmed' : 'Pending'}
            </div>
          </div>)}
        <div style={{
        padding: '0.85rem 1.2rem'
      }} data-id="element-187">
          <p style={{
          fontSize: '0.72rem',
          color: '#94a3b8',
          textAlign: 'center'
        }} data-id="element-188">
            Bookings arrive through WhatsApp — log them here manually as your
            fleet grows.
          </p>
        </div>
      </div>
    </div>;
};
// ─── APP ──────────────────────────────────────────────────────
export function App() {
  const initial = useScreenInit();
  const [view, setView] = useState(initial.view || 'public');
  const [legal, setLegal] = useState(null);
  return <>
      <FontLoader data-id="element-189" />
      {view === 'admin' ? <AdminPanel onBack={() => setView('public')} data-id="element-190" /> : <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column'
    }} data-id="element-191">
          {view === 'login' && <LoginModal onSuccess={() => setView('admin')} onClose={() => setView('public')} data-id="element-192" />}
          <Navbar onAdminClick={() => setView('login')} data-id="element-193" />
          <Hero data-id="element-194" />
          <PriceStrip data-id="element-195" />
          <CarSection data-id="element-196" />
          <Features data-id="element-197" />
          <PublicCalendarSection data-id="element-198" />
          <CTASection data-id="element-199" />
          <Footer onOpenLegal={setLegal} data-id="element-200" />
        </div>}
      {legal && <LegalModal type={legal} onClose={() => setLegal(null)} data-id="element-201" />}
    </>;
}